import { FC, ReactNode, useEffect, useMemo, useState } from "react";
import { MasterDataTable } from "../../../components/DataTable/MasterDataTable";
import { TableColumn } from "react-data-table-component";
import { Modal } from "bootstrap";
import useUser from "../../../hooks/User";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useIntl } from "react-intl";
import { DetailLimit, IReimbursementLimit } from "../../../interfaces/ReimbursementLimit";
import moment from "moment";
import { currencyFormatter, customNumberFormat, toRupiah, toUSD } from "../../../functions/general";
import { DateRangePicker } from 'rsuite';
import usePredefinedRanges from '../../../hooks/PredefinedRanges';
import useCalendarLocale from '../../../hooks/CalendarLocale';
import { endOfMonth, startOfMonth, endOfYear, startOfYear, setMonth, subYears, addYears, subDays } from 'date-fns';
import { mutate } from 'swr';
import { UpdateReimbursementLimit } from "../../../components/ReimbursementLimit/UpdateReimbursementLimit";
// import { DeleteReimbursementLimit } from "../../../components/ReimbursementLimit/DeleteReimbursementLimit";
import { AddReimbursementLimit } from "../../../components/ReimbursementLimit/AddReimbursementLimit";
import { FilterReimbursementLimit } from "../../../components/ReimbursementLimit/FilterReimbursementLimit";
import { MasterDataTableTanstack } from "../../../components/DataTable/MasterDataTableTanstack";
import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import { classNames } from "primereact/utils";
import clsx from "clsx";
import { right } from "@popperjs/core";
import zIndex from "@mui/material/styles/zIndex";
import Select from "react-select"
import { CURRENCY } from "../../../constant/General";
import { useCustomeStore } from "../../../stores/CustomeStore";
import { useDataTableStore } from "../../../stores/DataTableStore";
import { DeleteReimbursementLimit } from "../../../components/ReimbursementLimit/DeleteReimbursementLimit";
import useModalEffect from "../../../hooks/useModalEffect";
import useDynamicTab from "../../../hooks/useDynamicTab";

const allMonthYear = (start: Date, end: Date): Array<string> => {
    let months = [];
    let currentDate = moment(start); // Initialize a moment object from the start date

    while (currentDate <= moment(end)) {
        months.push(currentDate.format('MMM YYYY')); // Format the date as "Month Year"
        currentDate.add(1, 'months'); // Move to the next month
    }

    return months;
};

const getAllYears = (startDate: Date, endDate: Date): Array<string> => {
    const startYear = moment(startDate).year(); // Mengambil tahun dari startDate
    const endYear = moment(endDate).year();     // Mengambil tahun dari endDate
  
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year.toString());
    }
  
    return years;
  };


type RowData = {
    userName: string;
    roleName: string;
    [key: `month_${string}_${string}` | `year_${string}`]: IReimbursementLimit;  };
  interface ISelectCurrency {
    currency: string;
    setCurrency: (value: string) => void;
  }
let SelectCurrency = ({currency, setCurrency}:ISelectCurrency)=>{
    const customStyles = {
        control: (base:any) => ({
          ...base,
          height: 40,
          minHeight: 40,
          minWidth:150,
          position: "relative",
          top:7,
        })
      };
    const currencyOption = [
        {label: "USD",value:"840"},
        {label: "IDR",value:"360"},
    ]
    const handleChangeSelect = (value:any) => {
        setCurrency(value);
      };
    return (
        <Select options={currencyOption} styles={customStyles} defaultValue={currencyOption.find((option)=>option.value==currency)} value={currencyOption.find((option)=>option.value===currency)} onChange={(option) => {
            setCurrency(option?.value as string);
          }}/>
    )
}


const ReimbursementLimits: FC = () => {

    const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false);
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);    
    const user = useUser();
    const intl = useIntl()
    const [limit, setLimit] = useState<IReimbursementLimit>();
    const [currency, setCurrency ] = useState<string>(CURRENCY.IDR)
    const {tablesData}=useDataTableStore()
    const predefinedRanges = usePredefinedRanges();
    const calendarLocale = useCalendarLocale();
    const today = new Date();
    const lastYear = subDays(startOfYear(today), 365); // Awal tahun lalu    
    const [startDate, setStartDate] = useState<Date>(startOfMonth(today));
    const [endDate, setEndDate] = useState<Date>(endOfYear(addYears(today, 0)));
    const [loading, setLoading] = useState<boolean>(true);
    const [isMobile, setIsMobile] = useState<boolean>(false);
    const API_URL = process.env.REACT_APP_API_URL

    

    const [monthYearFields, setMonthYearFields] = useState<Array<string>>(allMonthYear(startDate, endDate));
    const [yearFields, setYearFields] = useState<Array<string>>(getAllYears(startDate, endDate));
  
    useEffect(() => {
      setMonthYearFields(allMonthYear(startDate, endDate));
      setYearFields(getAllYears(startDate,endDate))
    }, [startDate, endDate]);

  

    
    const columns: ColumnDef<RowData, any>[] = [
          {
            id: 'userName',
            header: 'Name',
            accessorKey: 'userName',
            cell: (info) => info.getValue(),
            meta: {
              styleHeader: {
                'whiteSpace': 'nowrap',
                position: 'sticky',
                left: 0,
                top: 0,
                backgroundColor: 'white',
                zIndex: 1,
                padding: '10px',
                minWidth: "250px",
              },
              styleBody: {
                'whiteSpace': 'nowrap',
                backgroundColor: 'white',
                position: "sticky",
                left: 0,
                top: 0,
                zIndex: 1,
                minWidth: "250px",
              },
              isPinnedLeft: true,
              classNamesHeader:"border-bottom",
              classNames:"border-bottom",
            }
          },
          {
            id: 'roleName',
            header: 'Role',
            accessorKey: 'roleName',
            meta: {
              styleHeader: {
                'whiteSpace': 'nowrap',
                // position: 'sticky',
                left: "249px",
                top: 0,
                backgroundColor: 'white',
                zIndex: 2,
                padding: '10px',
              },
              styleBody: {
                'whiteSpace': 'nowrap',
                // position: 'sticky',
                left: "249px",
                top: 0,
                backgroundColor: 'white',
                zIndex: 2,
                padding: '10px',
              },
              classNamesHeader:"border-bottom",
              classNames:"border-bottom"
            }
          },
    ];

    yearFields.forEach((field) => {
      columns.push({
        id: `year_${field}`,
        accessorFn: (row: RowData) => row[`year_${field}`]?.amount,
        header: field,
        cell: (info) => {
            const row: any = info.row.original;
            const id = `year_${field}`;
            const cellData = row[id];
            const isSet = row[id]?.isSet;

            const getAmountView = () => {
              if (info.getValue() === null) {
                return "-";
              }
              if (currency === CURRENCY.IDR) {
                return currencyFormatter(info.getValue(), false, "IDR", {showPrefix:true});
              }
              return currencyFormatter(info.getValue(), false, "USD", {showPrefix:true});
            };
    
            return (
              <div
                style={{
                  backgroundColor: isSet ? "#E8FFF3" : "#fee0e0",
                  padding: "8px"
                }}
                onClick={() => {
                    setLimit({ ...cellData });
                    setShowUpdateModal(true);
                }}
                className={ clsx("limits-cell", "limits-cell-hover")}                  >
                {getAmountView()}
              </div>
            );
          },
          meta: {
            styleHeader: {
              'whiteSpace': 'nowrap'
            },
            styleBody: {
              textAlign: "center",
              'whiteSpace': 'nowrap',
              cursor: 'pointer'
            },
            classNames: "limits-cell border",
          }
      });
    });
  
    monthYearFields.forEach((field) => {
      const [monthName, year] = field.split(" ");
      const monthIndex = moment().month(monthName).format("M");
      columns.push({
        id: `month_${monthIndex}_${year}`,
        accessorFn: (row: RowData) => row[`month_${monthIndex}_${year}`]?.amount,
        cell: (info) => {
          const row: any = info.row.original;
          const id = `month_${monthIndex}_${year}`;
          const cellData = row[id];
          const isSet = row[id]?.isSet;      
          const getAmountView = () => {
            if (info.getValue() === null) {
              return "-";
            }
            if (currency === CURRENCY.IDR) {
              return currencyFormatter(info.getValue(), false, "IDR", {showPrefix:true});
            }
            return currencyFormatter(info.getValue(), false, "USD", {showPrefix:true});
          };
  
          return (
            <div
              style={{
                backgroundColor: isSet ? "#E8FFF3" : "#fee0e0",
                padding: "8px"
              }}
              onClick={() => {
                  setLimit({ ...cellData });
                  setShowUpdateModal(true);
              }}
              className={ clsx("limits-cell", "limits-cell-hover")}
            >
              {getAmountView()}
            </div>
          );
        },
        header: field,
        meta: {
          styleHeader: {
            'whiteSpace': 'nowrap'
          },
          styleBody: {
            textAlign: "center",
            'whiteSpace': 'nowrap',
            cursor: 'pointer'
          },
          classNames: "limits-cell border",
        }
      });
    });
    

    let actions: ReactNode[] = []
    actions.push(<SelectCurrency currency={currency} setCurrency={setCurrency}/>)

    if (user.data.is_superadmin) actions.push(<AddReimbursementLimit startDate={startDate} endDate={endDate} />,
       <FilterReimbursementLimit />
       )
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 666) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        };

        // Initial check
        handleResize();

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);


    useModalEffect({
      showModal: showUpdateModal,
      setShowModal: setShowUpdateModal,
      modalId: `update-limit-modal-${limit?.id}`,
    })

    useEffect(() => {
            mutate(`${API_URL}reimbursement-limits`);
    }, [startDate, endDate, currency]);

    useDynamicTab({ title: `${intl.formatMessage({ id: 'FORM.MENU.LIMITS' })} | CRM WooBlazz` });

    return (
        <>
            <div className="d-flex justify-content-between mb-5">
                <ol className="breadcrumb text-muted fs-6 fw-bold">
                    <li className="breadcrumb-item text-dark">{intl.formatMessage({ id: 'FORM.MENU.LIMITS' })}</li>
                </ol>
                <div>
                    <span className="me-5">{intl.formatMessage({ id: "MASTERS.DATATABLE.TYPE.DATE_STARTED" })}</span>
                    <DateRangePicker
                        cleanable={false}
                        character=" - "
                        format="dd MMM yyyy"
                        locale={calendarLocale}
                        value={[startDate, endDate]}
                        ranges={predefinedRanges}
                        placement="bottomEnd"
                        onChange={(value) => {
                            if (value && value.length === 2) {
                                setStartDate(value[0]);
                                setEndDate(value[1]);
                            }
                        }}
                        showOneCalendar={isMobile}
                        disabled={false}
                        isoWeek={true}
                    />
                </div>
            </div>
            <div className="card mb-6">
                <div className="card-body">
                            <MasterDataTableTanstack
                                tableKey="reimbursement-limits"
                                tableColumns={columns}
                                apiURL={`reimbursement-limits`}
                                dateStart={moment(startDate).format('YYYY-MM-DD')}
                                dateEnd={moment(endDate).format('YYYY-MM-DD')}
                                autoReload={true}
                                actions={actions}
                                setLoading={setLoading}
                                currency={currency}
                            />
                </div>
            </div>
            {
                showUpdateModal && <UpdateReimbursementLimit limit={limit!} periodStartFrom={startDate} periodStartTo={endDate} setStartDate={setStartDate} setEndDate={setEndDate} />
            }
            {
                showDeleteModal && <DeleteReimbursementLimit limit={limit!} />
            }

        </>
    )
}

export { ReimbursementLimits }